interface INameConfirmationModalProps {
    show: boolean;
    name: string;
    email: string;
    phone: string;
    address: string;
    isUsResident: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    t: (key: string, fallback: string) => string;
}

const NameConfirmationModal = ({ show, name, email, phone, address, isUsResident, onConfirm, onCancel, t }: INameConfirmationModalProps) => {
    if (!show) {
        return null;
    }

    const addressLabel = isUsResident
        ? t('Word_Address', 'Address')
        : t('DashLabel_CountryOfResidence', 'Country of Residence');

    return (
        <>
            <div
                id='NameConfirmationModal'
                className='modal fade in'
                role='dialog'
                style={{ display: 'block' }}
            >
                <div className='modal-dialog' role='document'>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <button
                                type='button'
                                className='close'
                                aria-label='Close'
                                onClick={onCancel}
                            >
                                <span aria-hidden='true'>&times;</span>
                            </button>
                            <h4 className='modal-title'>
                                {t('DashLabel_ConfirmInformation', 'Confirm Information')}
                            </h4>
                        </div>
                        <div className='modal-body'>
                            <p>
                                {t(
                                    'DashLabel_PleaseConfirmTheBelowInformation',
                                    'Please confirm the below information is correct before proceeding. All information must be correct to proceed with donation',
                                )}
                                .
                            </p>

                            <div className='row'>
                                <div className='col-xs-12 col-lg-5'>
                                    <strong>{t('Word_Name', 'Name:')}</strong>
                                </div>
                                <div className='col-xs-12 col-lg-7'>
                                    <span id='ConfirmName'>{name}</span>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-xs-12 col-lg-5'>
                                    <strong>{t('DashLabel_Email', 'Email:')}</strong>
                                </div>
                                <div className='col-xs-12 col-lg-7'>
                                    <span id='ConfirmEmail'>{email}</span>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-xs-12 col-lg-5'>
                                    <strong>{t('DashLabel_PhoneNumber', 'Phone Number:')}</strong>
                                </div>
                                <div className='col-xs-12 col-lg-7'>
                                    <span id='ConfirmPhone'>{phone}</span>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-xs-12 col-lg-5'>
                                    <strong><span id='ConfirmAddressLabel'>{addressLabel}</span>:</strong>
                                </div>
                                <div className='col-xs-12 col-lg-7'>
                                    <span id='ConfirmAddress'>{address}</span>
                                </div>
                            </div>
                        </div>
                        <div className='modal-footer'>
                            <button
                                type='button'
                                className='btn btn-success'
                                style={{ width: 200 }}
                                onClick={onConfirm}
                            >
                                {t('DashLabel_YestThatsCorrect', 'Yes, that\'s correct')}
                            </button>
                            <button
                                type='button'
                                className='btn btn-warning'
                                style={{ width: 200 }}
                                onClick={onCancel}
                            >
                                {t('DashLabel_YesThatsIncorrect', 'No, that\'s incorrect')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className='modal-backdrop fade in' onClick={onCancel} />
        </>
    );
};

export default NameConfirmationModal;
